$(document).ready(function() {
    const $elementsToWrap = $('.gravityforms-container .is-style-gravityforms-layout > *:not(.gform_wrapper)');
    if ($elementsToWrap.length) {
        $elementsToWrap.wrapAll('<div class="content-wrapper"></div>');
    }

    const $gform_wrapper = $('.gform_wrapper');
    const $container = $('.is-style-gravityforms-layout');
    let resizeTimer;

    // Adjusts the margin based on scroll position and window width
    function adjustMargin() {
        // Check if both $container and $gform_wrapper exist
        if ($container.length === 0 || $gform_wrapper.length === 0) {
            return; // Exit the function if either element is missing
        }

        if ($(window).width() > 1400) {
            const containerTop = $container.offset().top;
            const scrollTop = $(window).scrollTop();
            const effectiveScroll = Math.max(0, scrollTop - containerTop + 136);
            const maxScroll = $container.outerHeight() - $gform_wrapper.outerHeight();
            $gform_wrapper.css('margin-top', `${Math.min(effectiveScroll, maxScroll)}px`);
        } else {
            $gform_wrapper.css('margin-top', '');
        }
    }

    // Debounce resize event
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(adjustMargin, 250);
    });

    // Throttle scroll event using requestAnimationFrame
    let isScrolling = false;
    $(window).on('scroll', function() {
        if (!isScrolling) {
            requestAnimationFrame(function() {
                adjustMargin();
                isScrolling = false;
            });
        }
        isScrolling = true;
    });

    adjustMargin(); // Initial call to adjust margin
});


// WEBPACK FOOTER //
// ./scripts/gravityforms-layout.js